import React, {useEffect} from "react"
import CsvDownloader from "react-csv-downloader"
import {BaseButton} from "../components"
import {useStore, useDispatch} from "../Store"
import {getSetListCSV} from "../api"
import {useTranslation} from "react-i18next"
import "../i18n"
import {useCookies} from "react-cookie"
import {getTokenCookie, isAmOne} from "../common"

export default function DownloadEquityCategorySet({group = null, type = null}) {
  const [cookies] = useCookies([])
  const {t} = useTranslation()
  const {
    store: {perspective, categoryListCSV, categoryCsvState, mainGroup, tabs},
  } = useStore()
  const {dispatch} = useDispatch()

  useEffect(() => {
    const fetch = async () => {
      if (!isAmOne()) return
      const param = {
        group,
        type,
      }
      let index = 2
      if (group === mainGroup[0]) index = 0
      if (group === mainGroup[1]) index = 1
      const data = await getSetListCSV(getTokenCookie(cookies), param)
      data.sort((a, b) => (a.value > b.value ? 1 : -1))
      categoryListCSV[index] = data
      dispatch({
        type: `LOADED_CATEGORY_CSV`,
        categoryCsvState: true,
      })
    }
    if (!categoryCsvState) fetch()
  }, [])

  return (
    <CsvDownloader filename={`SimilarChart${group}Category`} suffix datas={categoryListCSV[perspective]} bom={false}>
      <BaseButton label={`${group}${t(`downloadCategory`)}`} color="blue" />
    </CsvDownloader>
  )
}
